import React, { useState } from "react";
import Configuration from "../../components/settings/youtube/Configuration";

const YoutubeConfiguration = () => {
  const [activeTabIndex, setActiveTabIndex] = useState<any>(0);
  const tabTitles = ["Youtube"];

  const mappingObj = {
    0: <Configuration />,
  };

  return (
    <div className="text-start">
      <div>
        <ul className="nav nav-stretch nav-line-tabs text-primary border-transparent d-flex flex-nowrap mb-5">
          {tabTitles?.map((title, index) => (
            <li className="nav-item">
              <span
                style={{ textAlign: "center" }}
                className={`nav-link cursor-pointer fs-4 fw-bold ${
                  activeTabIndex === index ? "active fw-bolder" : ""
                }`}
                onClick={() => {
                  setActiveTabIndex(index);
                }}
                role="tab"
              >
                {title}
              </span>
            </li>
          ))}
        </ul>
      </div>

      {mappingObj[activeTabIndex]}
    </div>
  );
};

export default YoutubeConfiguration;
